import { useSuspenseQuery } from '@apollo/client'
import { FetchGoalConfigsDocument } from '@salescore/client-api'
import { useCan } from '@salescore/client-common'
import { createFileRoute } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { ImportGoalsFormV3 } from '../../../../../../../components/ImportGoalsFormV3'

const Page = (): ReactNode => {
  const { goalConfigId, organizationId } = Route.useParams()
  // 大したレコード数にならない想定なので、全取得している
  const {
    data: { goalConfigs, userGroups },
  } = useSuspenseQuery(FetchGoalConfigsDocument, {
    variables: {
      organizationId,
    },
  })

  const canManageGoal = useCan(`manage-goal`)
  const { t } = useTranslation()
  if (!canManageGoal) {
    return <div>{t(`設定権限がありません。`)}</div>
  }

  const goalConfig = goalConfigs.find((x) => x.id === goalConfigId)

  if (goalConfig === undefined) {
    return <div>{t(`目標が見つかりません`)}</div>
  }

  return <ImportGoalsFormV3 goalConfig={goalConfig} userGroups={userGroups} organizationId={organizationId} />
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/goal_configs/$goalConfigId/csv')({
  component: Page,
})
